//only to restrict customer from login at subscription page this component is created

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import { Form, PrimaryButton, FieldTextInput, NamedLink } from '../../../components';

import css from './LoginForm.module.css';
import { useState } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../../../util/api';

const LoginFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        intl,
        invalid,
        loginOrSignupError,
        showSignUpLink,
        setIsLogin,
        values,
      } = fieldRenderProps;

      // email
      const emailLabel = intl.formatMessage({
        id: 'LoginForm.emailLabel',
      });
      const emailPlaceholder = intl.formatMessage({
        id: 'LoginForm.emailPlaceholder',
      });
      const emailRequiredMessage = intl.formatMessage({
        id: 'LoginForm.emailRequired',
      });
      const emailRequired = validators.required(emailRequiredMessage);
      const emailInvalidMessage = intl.formatMessage({
        id: 'LoginForm.emailInvalid',
      });
      const emailValid = validators.emailFormatValid(emailInvalidMessage);

      // password
      const passwordLabel = intl.formatMessage({
        id: 'LoginForm.passwordLabel',
      });
      const passwordPlaceholder = intl.formatMessage({
        id: 'LoginForm.passwordPlaceholder',
      });
      const passwordRequiredMessage = intl.formatMessage({
        id: 'LoginForm.passwordRequired',
      });
      const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;

      const passwordRecoveryLink = (
        <NamedLink name="PasswordRecoveryPage" className={css.recoveryLink}>
          <FormattedMessage id="LoginForm.forgotPassword" />
        </NamedLink>
      );

      const [loginTypeError, setLoginTypeError] = useState(null);
      const [loginInProgress, setLoginInProgress] = useState(false);

      return (
        <Form
          className={classes}
          onSubmit={e => {
            setLoginInProgress(true);
            e.preventDefault();
            setLoginTypeError(null);
            axios
              .get(`${apiBaseUrl()}/api/getUserType/${values.email}`)
              .then(resp => {
                setLoginInProgress(false);
                if (
                  resp.data.data.userType === 'cliente-id' ||
                  resp.data.data.userType === 'cliente'
                ) {
                  return setLoginTypeError(
                    intl.formatMessage({ id: 'LoginForm.customerLoginNotAllowed' })
                  );
                } else {
                  handleSubmit();
                }
              })
              .catch(err => {
                setLoginInProgress(false);
                setLoginTypeError(null);
                // handleSubmit();
              });
          }}
        >
          <div>
            <FieldTextInput
              type="email"
              id={formId ? `${formId}.email` : 'email'}
              name="email"
              autoComplete="email"
              label={emailLabel}
              placeholder={emailPlaceholder}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
            <FieldTextInput
              className={css.password}
              type="password"
              id={formId ? `${formId}.password` : 'password'}
              name="password"
              autoComplete="current-password"
              label={passwordLabel}
              placeholder={passwordPlaceholder}
              validate={passwordRequired}
            />
          </div>
          <div className={css.bottomWrapper}>
            <p className={css.bottomWrapperText}>
              <span className={css.recoveryLinkInfo}>
                <FormattedMessage
                  id="LoginForm.forgotPasswordInfo"
                  values={{ passwordRecoveryLink }}
                />
              </span>
            </p>
            {loginOrSignupError}
            {loginTypeError && <div className={css.errMsg}>{loginTypeError}</div>}

            <PrimaryButton
              type="submit"
              inProgress={submitInProgress || loginInProgress}
              disabled={submitDisabled}
            >
              <FormattedMessage id="LoginForm.logIn" />
            </PrimaryButton>

            {showSignUpLink && typeof setIsLogin === 'function' ? (
              <div className={css.signupLink}>
                <span>
                  <FormattedMessage id="LoginForm.noAccount" />
                </span>
                <span
                  className={css.link}
                  onClick={() => typeof setIsLogin === 'function' && setIsLogin(false)}
                >
                  <FormattedMessage id="LoginForm.signUp" />
                </span>
              </div>
            ) : null}
          </div>
        </Form>
      );
    }}
  />
);

LoginFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  form: null,
  inProgress: false,
};

const { string, bool } = PropTypes;

LoginFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  form: string,
  inProgress: bool,
  intl: intlShape.isRequired,
};

const ProviderLoginForm = compose(injectIntl)(LoginFormComponent);
ProviderLoginForm.displayName = 'LoginForm';

export default ProviderLoginForm;
